'use strict'

module.exports = '@resolver'
